import { render, staticRenderFns } from "./revenueForProperty.vue?vue&type=template&id=8c8d10ea&scoped=true"
import script from "./revenueForProperty.vue?vue&type=script&lang=js"
export * from "./revenueForProperty.vue?vue&type=script&lang=js"
import style0 from "./revenueForProperty.vue?vue&type=style&index=0&id=8c8d10ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c8d10ea",
  null
  
)

export default component.exports